import React, { useEffect, useState } from "react";
import http from "../lib/http";
import AdminLayout from "./AdminLayout";

export default function AdminLeadsPage() {

  const [leads, setLeads] = useState([]);

  useEffect(() => {
    loadLeads();
  }, []);

  const loadLeads = async () => {
    const res = await http.get("/api/leads");
    setLeads(res.data);
  };

  const updateStatus = async (id, status) => {
    await http.put(`/api/leads/${id}/status`, {
      status
    });

    loadLeads();
  };

  return (
    <div>
      <h3 className="mb-4">Lead Management</h3>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Customer</th>
            <th>Phone</th>
            <th>Dealer</th>
            <th>Requirement</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>

          {leads.map((lead) => (

            <tr key={lead._id}>

              <td>
                {new Date(
                  lead.createdAt
                ).toLocaleDateString()}
              </td>

              <td>
                {lead.customerName}
              </td>

              <td>
                {lead.customerPhone}
              </td>

              <td>
                {lead.dealerName}
              </td>

              <td>
                {lead.enquiryMessage}
              </td>

              <td>
                <select
                  className="form-select"
                  value={lead.status}
                  onChange={(e)=>
                    updateStatus(
                      lead._id,
                      e.target.value
                    )
                  }
                >
                  <option>New</option>
                  <option>Contacted</option>
                  <option>Closed</option>
                </select>
              </td>

            </tr>

          ))}

        </tbody>
      </table>
    </div>
  );
}